import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal, DatePicker, Viewer, Tooltip } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { AssistantService } from 'services';
import moment from 'moment';
import { UserIcon, ViewIcon } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any;
	item: any;
}

const TABS = {
	INFO: 1,
	FILES: 2
}

class ModalView extends React.Component<Props> {

	state = {
		assistant: null,
		nationalities: [],
		visible: false,
		file: null,
		tab: TABS.INFO
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await AssistantService.view({
			assistant_id: this.props.item?.id
		});
		this.setState({
			assistant: res.assistant,
			nationalities: res.nationalities || []
		});
	}

	viewFile = (e: any, file: string) => {
		e.preventDefault();
		this.setState({
			file,
			visible: true
		});
	}

	render() {
		const assistant: any = this.state.assistant;
		const { visible, tab } = this.state;

		const FILES = [
			{
				file: Constants.ASSISTANT_FILES.PHOTO,
				name: 'Foto / Logo de Perfil'
			},
			{
				file: Constants.ASSISTANT_FILES.ID,
				name: 'Cédula',
				className: 'document-photo'
			},
			{
				file: Constants.ASSISTANT_FILES.MEDICAL_CERTIFICATE,
				name: 'Certificado de Salud',
				className: 'document-photo'
			},
			{
				file: Constants.ASSISTANT_FILES.FOOD_HANDLING,
				name: 'Manipulación de alimentos',
				className: 'document-photo'
			}
		];

		return (
			<div id="modal-view-assistant">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setState({ visible: false }) }
			      images={ [{ src: this.state.file }] }
			    />

				<div className="row">
					<div className="col-md-12">
						<div className="tabs">
							<button
								type="button"
								className="tab"
								onClick={() => this.setState({ tab: TABS.INFO }) }
								data-active={ tab == TABS.INFO }
							>
								Información
							</button>

							<button
								type="button"
								className="tab"
								onClick={() => this.setState({ tab: TABS.FILES }) }
								data-active={ tab == TABS.FILES }
							>
								Documentos
							</button>
						</div>
					</div>
					{
						tab == TABS.INFO && (
							<>
								<div className="col-md-6">
									<div className="input-group">
										<Input
											label="Nombres"
											value={assistant?.name}
											name="name"
											notMui
											disabled
										/>
									</div>
									<div className="input-group">
										<Input
											label="Apellidos"
											value={assistant?.lastname}
											name="lastname"
											notMui
											disabled
										/>
									</div>
									<div className="input-group">
										<Input
											type="number"
											label="Cédula"
											value={assistant?.document}
											name="document"
											notMui
											disabled
										/>
									</div>
									<div className="input-group">
										<Select
											name="nationality_id"
											label="Nacionalidad"
											value={ assistant?.nationality_id }
											disabled
											options={ this.state.nationalities.map((item: any) => {
												return {
													value: item.id,
													label: item.name
												}
											}) }
										/>
									</div>
									<div className="input-group">
										<DatePicker
				                          label="Fecha de nacimiento"
				                          placeholder="Fecha"
				                          disabled
				                          maxDate={moment().toDate()}
				                          value={assistant?.birthdate ? moment(assistant?.birthdate).toDate() : ''}
				                        />
									</div>
								</div>
								<div className="col-md-6">
									<div className="input-group">
										<Input
											disabled
											label="Email"
											value={assistant?.email}
											name="email"
											notMui
										/>
									</div>
									<div className="input-group">
										<Input
											disabled
											label="Lugar de Nacimiento"
											value={assistant?.birth_city}
											name="birth_city"
											notMui
										/>
									</div>
									<div className="input-group">
										<Select
											disabled
											label="Sexo"
											name="gender"
											value={ assistant?.gender }
											options={ [
												{ value: 'M', label: 'Masculino' },
												{ value: 'F', label: 'Femenino' },
											] }
										/>
									</div>
									<div className="input-group">
										<Input
											disabled
											type="number"
											maxLength={ 11 }
											label="Teléfono"
											value={assistant?.phone}
											name="phone"
											notMui
										/>
									</div>
									<div className="input-group">
										<Input
											disabled
											label="Zona donde reside"
											value={assistant?.city}
											name="city"
											notMui
										/>
									</div>
								</div>
							</>
						)
					}
					
					{
						tab == TABS.FILES && (
							<>
								{
									FILES.map((file: any) => {
										const _file = assistant?.files?.find((i: any) => i.type_id == file?.file)?.file;

										if (_file)
											return (
												<>
													<div className="col-md-6" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
														<div className={ `photo-wrapper-file ${ file?.className || '' } ${ _file?.endsWith('.pdf') ? 'pdf' : '' }` }>
															{
																assistant != null && (
																	<a href="#" onClick={ (e: any) => this.viewFile(e,Constants.BASE_STORAGE + _file) }>
																		<FallbackImage
																			src={ Constants.BASE_STORAGE + _file }
																			placeholder={UserIcon}
																			className="fb-img"
																			placeholderClassName="fb-img-placeholder"
																		/>
																	</a>
																)
															}
														</div>
														<p className="card-foot">
															{ file?.name } 
															{
																_file?.endsWith('.pdf') && (
																	<Tooltip title="Ver">
																		<a href={ Constants.BASE_STORAGE + _file } target="_blank">
																			<img src={ ViewIcon } className="view-icon" />
																		</a>
																	</Tooltip>
																)
															}
														</p>
													</div>
												</>
											)
										})
								}
							</>
						)
					}
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalView);